import { getGoodjobLink } from '@utils/getGoodjobLink';

export const navList = [
  {
    code: 'home',
    name: '首页',
    url: '/home',
    activeUrl: ['/web/home'],
    bid: 'b_ead_rfccd8hm_mc',
  },
  {
    code: 'beidou',
    name: '北斗计划',
    url: '/beidouprogram',
    activeUrl: ['/web/beidouprogram'],
    bid: 'b_ead_5nawti7j_mc',
  },
  {
    code: 'social',
    name: '社会招聘',
    url: '/social',
    activeUrl: ['/web/social'],
    bid: 'b_ead_ciwc4f11_mc',
  },
  {
    code: 'campus',
    name: '校园招聘',
    url: '/campus',
    // activeUrl: ['/web/campus', '/web/qihang', '/web/campus/tv'],
    activeUrl: ['/web/campus', '/web/qihang'],
    bid: 'b_ead_iep80xq5_mc',
  },
  {
    code: 'gzjz',
    name: '工作兼职',
    url: getGoodjobLink(),
    bid: '',
    target: '_blank',
  },
  {
    code: 'about',
    name: '了解美团',
    url: '/about/ourTeam?bg=BG005',
    activeUrl: ['/web/about/ourTeam', '/web/about/workInMeituan'],
    bid: 'b_ead_x46v5e22_mc',
  },
  {
    code: 'question',
    name: '常见问题',
    url: '/question/social',
    activeUrl: ['/web/question/social', '/web/question/campus', '/web/question/announcement', '/web/campus/schedule'],
    bid: 'b_ead_guu7rgpg_mc',
  },
  // {
  //   code: 'personalCenter',
  //   name: '个人中心',
  //   url: '/personalCenter/resumeDetail',
  //   activeUrl: [
  //     '/web/personalCenter/resumeDetail',
  //     '/web/personalCenter/deliveryRecord',
  //     '/web/personalCenter/accountSetting',
  //   ],
  // },
];

export const dropNavList = [
  {
    code: 'resumeDetail',
    name: '我的简历',
    linkUrl: '/personalCenter/resumeDetail',
  },
  {
    code: 'deliveryRecord',
    name: '投递记录',
    linkUrl: '/personalCenter/deliveryRecord',
  },
  {
    code: 'accountSetting',
    name: '账号设置',
    linkUrl: '/personalCenter/accountSetting',
  },
  {
    code: 'logout',
    name: '退出登录',
    linkUrl: '/home', // 产品殷程蔚让退出后跳首页
  },
];

export const focusList = [
  {
    code: 'wechat',
    imgUrl: require('@imgs/wechat.svg'),
    erweiImg: require('@imgs/footer/public.png'),
    desc: '关注美团招聘公众号',
  },
  {
    code: 'shipin',
    imgUrl: require('@imgs/shipinhao.svg'),
    erweiImg: require('@imgs/footer/shipinhao.png'),
    desc: '关注美团招聘视频号',
  },
  {
    code: 'bilibili',
    imgUrl: require('@imgs/bilibili.svg'),
    erweiImg: require('@imgs/footer/bilibili.png'),
    desc: '关注美团招聘B站号',
    linkUrl: 'https://space.bilibili.com/527094538',
  },
  {
    code: 'byteDance',
    imgUrl: require('@imgs/byteDance.svg'),
    erweiImg: require('@imgs/footer/douyin.png'),
    desc: '关注美团招聘抖音号',
  },
  {
    code: 'weibo',
    imgUrl: require('@imgs/weibo.svg'),
    erweiImg: require('@imgs/footer/weibo.png'),
    desc: '关注美团招聘微博号',
    linkUrl: 'https://weibo.com/u/2293623823',
  },
  {
    code: 'red',
    imgUrl: require('@imgs/red.png'),
    erweiImg: require('@imgs/footer/red.png'),
    desc: '关注美团招聘小红书号',
  },
  {
    code: 'lingying',
    imgUrl: require('@imgs/lingying.svg'),
    erweiImg: require('@imgs/footer/lingying.png'),
    desc: '关注美团招聘领英号',
    linkUrl: 'https://www.linkedin.cn/incareer/company/meituan',
  },
];
export const pathInfo = {
  home: '/home',
  position: '/position',
  social: '/social',
  campus: '/campus',
  questionSocial: '/question/social',
  questionCampus: '/question/campus',
  questionAnnouncement: '/question/announcement',
  beidou: '/beidou',
  beidouprogram: '/beidouprogram',
  qihang: '/qihang',
  workInMeituan: '/about/workInMeituan',
  ourTeam: '/about/ourTeam',
};
